import script from "./trace-log.vue?vue&type=script&setup=true&lang=js"
export * from "./trace-log.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__